import { ClickableProChip } from "./ProChip";
import { useState } from "react";
import { TrialProModal } from "./TrialProModal";
import { styled, Typography } from "@mui/material";

const ProChipLabel = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  fontWeight: 600,
  fontFamily: "Poppins",
  color: theme.palette.primary.dark,
  position: "relative",
  zIndex: 2,
}));

const StyledProChip = styled(ClickableProChip)(({ theme }) => ({
  width: "100px",
  height: "20px",
  borderRadius: "12px",
  cursor: "pointer",
  background: theme.palette.background.proChip,
}));

export const TrialProChip = () => {
  const [showTrialProModal, setShowTrialProModal] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const label = <ProChipLabel>MekiDoc PRO</ProChipLabel>;

  return (
    <>
      <StyledProChip
        elevation={isHovered ? 4 : 2}
        onClick={() => setShowTrialProModal(true)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {label}
      </StyledProChip>
      <TrialProModal
        showTrialProModal={showTrialProModal}
        setShowTrialProModal={setShowTrialProModal}
      />
    </>
  );
};
